import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {

    let data = qs.stringify(params)
    return axios.request({
        url: '/banner/banner-list',
        data,
        method: 'post'
    })
};
// 新增修改
export const addModify = (params) => {

    let data = qs.stringify(params)
    return axios.request({
        url: '/banner/save-banner',
        data,
        method: 'post'
    })
};
// 获取详情
export const fetchInfo = (params) => {

    let data = qs.stringify(params)
    return axios.request({
        url: '/banner/banner-info',
        data,
        method: 'post'
    })
};
//删除
export const setDel = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/banner/banner-delete',
        data,
        method: 'post'
    })
};
// 获取课程下拉
export const fetchClassList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/classes/lesson-list',
        data,
        method: 'post'
    })
};